export default "__VITE_ASSET__HCDMPdHQ__"